import InfoBox from './Infobox'

export default InfoBox
